// src/modules/app-views/suppliers/pages/Init/actions/menuButton.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { ImportOutlined, DatabaseOutlined } from '@ant-design/icons';
import showMigrationDocumentModal from 'components/core/migration/MigrationDocumentModal';
import showMigrationModal from 'components/core/migration/MigrationSettingsModal';
import { dropdownDivider, dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';
import appService from 'services/appService';

// *******************************************************************************
// MENU BUTTON
// *******************************************************************************
const suppliersInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [
      dropdownParameters,
      dropdownDivider,

      // Import Document - visible only when migration token is active
      {
        key: 'importSupplier',
        label: 'migrate_document',
        icon: <ImportOutlined />,
        hidden: ({ storedSubscription }) => {
          const tokens = storedSubscription?.migrationTokens || [];
          const suppliersToken = tokens.find(t => t.collectionName === 'suppliers');
          return !suppliersToken?.isActive;
        },
        onClick: ({ refresh }) => {
          showMigrationDocumentModal({
            collection: 'fornecedores', // Source collection name (Portuguese)
            onSuccess: () => refresh?.(),
          });
        },
      },

      // Migration settings
      {
        key: 'suppliersMigrationSettings',
        label: 'migratory',
        icon: <DatabaseOutlined />,
        onClick: ({ refresh }) => {
          // Get entityPersonType to determine enrichment options
          const formPrefs = appService.getModulePreferences({ category: 'form' });
          const entityPersonType = formPrefs?.entityPersonType || 'manual';

          // Enrichment visibility logic based on entityPersonType:
          // manual   → CNPJ: true,  CPF: true
          // company  → CNPJ: true,  CPF: false
          // person   → CNPJ: false, CPF: true
          const showCnpjEnrichment = entityPersonType !== 'person';
          const showCpfEnrichment = entityPersonType !== 'company';

          showMigrationModal({
            showCnpjEnrichment,
            showCpfEnrichment,
            showProductsEnrichment: false, // Not applicable for suppliers
            onSuccess: () => refresh?.(),
          });
        },
      },
    ],
  };
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default suppliersInitMenuButton;
